import React from 'react';
import ContentLoader from 'react-content-loader';

const FreeEventRegistrationPageSkeleton = () => (
  <ContentLoader
    width="100%"
    backgroundColor="var(--neutral-200)"
    foregroundColor="var(--neutral-400)"
    height={486}
  >
    <rect x="0" y="0" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="20" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="71" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="91" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="146" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="166" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="221" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="241" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="296" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="316" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="371" rx="0" ry="0" width="100" height="16" />
    <rect x="0" y="391" rx="0" ry="0" width="100%" height="39" />

    <rect x="0" y="446" rx="0" ry="0" width="100%" height="40" />
  </ContentLoader>
);

export default FreeEventRegistrationPageSkeleton;
